import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const WorkItemAgreementsContext = createContext();

export default function WorkItemAgreementsProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [currentWorkItemAgreements, setWorkItemAgreements] = useState([]);

  const updateWorkItemAgreements = async () => {
    logger.debug(
      "WorkItemAgreementsProvider.updateWorkItemAgreements",
      `GET field/WIAgreements`
    );
    const data = await auth.get(`field/WIAgreements`);
    if (data) {
      // data should be an array of strings
      logger.debug(
        "WorkItemAgreementsProvider.updateWorkItemAgreements",
        `Retrieved data`
      );
      data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
      if (data) {
        setWorkItemAgreements(data);
      } else {
        setWorkItemAgreements([]);
      }

      return data;
    }
    logger.debug(
      "WorkItemAgreementsProvider.updateWorkItemAgreements",
      `Failed to retrieve data`
    );
    return [];
  };

  const getWorkItemAgreements = () => currentWorkItemAgreements;

  return (
    <WorkItemAgreementsContext.Provider
      value={{
        getWorkItemAgreements,
        updateWorkItemAgreements,
      }}
    >
      {children}
    </WorkItemAgreementsContext.Provider>
  );
}

WorkItemAgreementsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useWorkItemAgreements = () =>
  useContext(WorkItemAgreementsContext);
